import React, { useEffect, useState } from 'react'
import LayoutUser from '../../components/layout_user'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { fetchSpecificItem } from '../../../flux/items'
import { addItem } from '../../../flux/cart'
import { setNotification } from '../../../flux/notification'
import Container from '../../components/container'
import Data from './data'
import Skeleton from './skeleton'
// import Related from './related'
import styled from 'styled-components'
import Cover from '../../components/layout_user/cover'
import CoverPrimarySrc from '../../../assets/coverPrimary.jpg'
import { useMediaQuery } from '@material-ui/core'
import Header from '../../pages/home/header'
// import category from '../../../config'

const Item = props => {
  const { id } = useParams()
  const dispatch = useDispatch()
  var { items, loading } = useSelector(state => state.items)
  const itemSelected = items[id] || null
  const [quantity, setQuantity] = useState(1)
  const isMobile = useMediaQuery('(max-width:600px)')

  // focus
  useEffect(() => {
    setTimeout(() => {
      try {
        window.scrollTo(0, (document.getElementById('item_focus').offsetTop - (isMobile ? 300 : 100)))
      } catch (error) {
        console.log('algo salio mal', error)
      }
    }, 10)
  }, [loading, isMobile])

  // fetch data
  useEffect(() => {
    if (!itemSelected) dispatch(fetchSpecificItem(id))
  }, [])

  const AddToCart = event => {
    dispatch(setNotification({
      type: 'success',
      message: `Se han agregado ${quantity} ${itemSelected.title} a tu carrito`
    }))
    dispatch(addItem({ ...itemSelected, quantity }))
  }

  const onQuantityChange = event => {
    var newValue = event.target.value
    if (newValue === '') {
      setQuantity('')
      return false
    }
    newValue = parseInt(newValue)
    if (isNaN(newValue)) newValue = 1
    setQuantity(newValue)
  }

  // move to up
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [id])

  return (
    <>
      <LayoutUser>
        <Cover
          maxWidth='1520px'
          picture={CoverPrimarySrc}
          title='Solicita tus estudios en línea'
          text='Ahora puedes comprar tus estudios sin salir de casa.
          Ponemos a tu disposición nuestras pruebas más solicitadas'
        />
        {loading && (
          <Container>
            <Skeleton />
          </Container>
        )}
        {!loading && (
          <ContainerOnlyDesk id='item_focus'>
            <Header />
            <Data
              AddToCart={AddToCart}
              {...itemSelected}
              onQuantityChange={onQuantityChange}
              quantity={quantity}
              setQuantity={setQuantity}
            />
          </ContainerOnlyDesk>
        )}
      </LayoutUser>
    </>
  )
}

const ContainerOnlyDesk = styled(Container)`
  width: 85%;
  max-width: 85%;
  @media (max-width:950px) {
    width: 95%;
    max-width: 95%;
  }
`

export default Item
